import styled from "styled-components";

// Depoimentos reais recebidos durante e após a mentoria. Compartilhado entre
// Home, Assinaturas e MentoriaPage — antes só existia em /mentoria, então a
// melhor prova social do site (alguém aprovado numa vaga uma semana depois)
// nunca aparecia onde a decisão de assinar ou contratar de fato acontece.
export const testimonials = [
  {
    name: "Aluno",
    message:
      "Rogério, 1 semana depois que terminamos a mentoria, fui chamado para uma entrevista e hoje fiquei sabendo que fui aprovado. Muito obrigado, a mentoria me ajudou demais.",
    time: "21:46",
  },
  {
    name: "Aluno",
    message:
      "Sobre a mentoria, até aqui me ajudou bastante não somente sobre aprender igual a um curso, mas sim a esclarecer minhas dúvidas, me passar confiança. Eu também consegui entender muito melhor onde estava meu nível de conhecimento, coisas que vão além do convencional.",
    time: "12:04",
  },
  {
    name: "Aluno",
    message:
      "Sobre a mentoria, eu recomendaria demais por alguns fatores: 1) Conteúdo completo e bem explicado. 2) Envolve muita prática, então não fica preso somente em ler e tentar aplicar sem ter alguma direção. 3) O conteúdo condiz muito com o que é aplicado realmente no mercado e sobre como ele funciona. 4) Ter a oportunidade de conversar com alguém que tem muita experiência na área ajuda e muito, sempre tirando as dúvidas, mesmo as mais simples. Isso me ajudou bastante. 5) Os projetos utilizados já servem como base para ter um portfólio bem interessante.",
    time: "12:05",
  },
  {
    name: "Aluno",
    message:
      "Foi uma das melhores experiências de aprendizado que tive! Durante as semanas de mentoria, consegui fortalecer meus conhecimentos fundamentais em QA e ter uma visão mais ampla sobre a área, tanto em relação à atuação profissional quanto à forma de me posicionar no mercado. Além disso, a mentoria me deu uma direção muito importante para organizar melhor meu GitHub e meu LinkedIn. O que mais gostei foram os materiais extras disponibilizados ao longo das semanas, pois ajudaram bastante a complementar os estudos. Quanto aos pontos de melhoria, no momento não tenho nenhuma sugestão. A mentoria atendeu muito bem às minhas expectativas!",
  },
];

// Paleta de marca (navy claro + ciano) — os mesmos hex usados nos tokens
// locais `C` de Home/Assinaturas/MentoriaPage, fixos aqui porque este
// componente é compartilhado entre páginas com objetos `C` diferentes.
const surface = "#1F3050";
const border = "#1E2A45";
const accent = "#22B8D1";
const textPrimary = "#FFFFFF";
const muted = "#6B7A90";
const mono = '"JetBrains Mono", "SFMono-Regular", Consolas, monospace';

const Grid = styled.div`
  display: grid;
  gap: 18px;
  grid-template-columns: 1fr;

  @media (min-width: 760px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: 1120px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

const Card = styled.article`
  position: relative;
  display: grid;
  align-content: start;
  gap: 10px;
  padding: 18px 20px 20px;
  border: 1px solid ${border};
  border-radius: 18px;
  background: ${surface};
  box-shadow: 0 10px 26px rgba(10, 17, 30, 0.22);
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(34, 184, 209, 0.28);
    box-shadow: 0 16px 32px rgba(10, 17, 30, 0.26);
  }
`;

const Footer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 12px;
  margin-bottom: 2px;
  border-bottom: 1px solid ${border};
`;

const Avatar = styled.div`
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(34, 184, 209, 0.55), rgba(108, 143, 176, 0.55));
  color: #ffffff;
  font-weight: 800;
  font-size: 0.82rem;
`;

const Meta = styled.div`
  display: grid;
  gap: 2px;
  min-width: 0;
`;

// Nome real ocultado (blur) em vez de exibido de qualquer jeito — o dado que
// temos hoje é só "Aluno", então a marcação visual de "identidade redigida"
// é honesta com o que a informação realmente é.
const Name = styled.strong`
  width: fit-content;
  display: inline-block;
  color: ${textPrimary};
  font-size: 0.86rem;
  filter: blur(4px);
  user-select: none;
`;

const Role = styled.span`
  color: ${muted};
  font-size: 0.76rem;
`;

const Bubble = styled.div`
  position: relative;
  padding: 12px 14px;
  border-radius: 4px 16px 16px 16px;
  background: rgba(34, 184, 209, 0.08);
  border: 1px solid rgba(34, 184, 209, 0.16);
`;

const Text = styled.p`
  margin: 0;
  color: ${textPrimary};
  line-height: 1.6;
  font-size: 0.92rem;
`;

const Time = styled.span`
  display: block;
  margin-top: 8px;
  color: ${muted};
  font-family: ${mono};
  font-size: 0.68rem;
`;

export function TestimonialsGrid({ items = testimonials }) {
  return (
    <Grid>
      {items.map((testimonial, index) => (
        <Card key={`${testimonial.name}-${testimonial.time ?? index}`}>
          <Footer>
            <Avatar aria-hidden="true">A</Avatar>
            <Meta>
              <Name aria-label="Nome do aluno oculto">{testimonial.name}</Name>
              <Role>Aluno(a) da mentoria</Role>
            </Meta>
          </Footer>
          <Bubble>
            <Text>{testimonial.message}</Text>
            {testimonial.time && <Time>{testimonial.time}</Time>}
          </Bubble>
        </Card>
      ))}
    </Grid>
  );
}

export const testimonialAccent = accent;
